import { Location } from 'react-router-dom';
import { deleteParam } from '../utilsPublic/utilsPublic';

export const deleteSearchParam = (param: string, location: Location): void => {
	const searchParams = new URLSearchParams(
		location.search.toLocaleLowerCase(),
	);

	deleteParam(param, searchParams);

	window.history.pushState(
		'',
		'',
		`${location.pathname}${
			searchParams.toString() ? `?${searchParams.toString()}` : ''
		}`,
	);
};
